<div class="section__content flightbridge__content">
  <img src="assets/images/FBLogo2024Color.png" width="175" height="48" class="flightbridge__logo" alt="FlightBridge">
  <div>FlightBridge is the ultimate all-in-one travel booking platform built for the general aviation community.
  AOPA Members receive free access to FlightBridge with AOPA discounted rates automatically applied.
  Members save an average of 30% on hotel bookings! Learn more about FlightBridge <a target="_blank" class="flightbridge__link" href="https://www.aopa.org/travel/flightbridge">HERE</a>.</div>
  <div class="flightbridge__button-bar-container">
    <div class="flightbridge__button-inner-container">
      <div class="flightbridge__button-header">
        <mat-icon fontSet="fa" fontIcon="fa-bed"></mat-icon> Hotels
      </div>
      <div class="flightbridge__button">
        <a *ngIf="isMember" (click)="navigateToFlightBridge('hotel')" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Book Now
        </a>
        <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Join AOPA
        </a>
        <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Login/Create AOPA account
        </a>
      </div>
    </div>

    <div class="flightbridge__button-inner-container">
      <div class="flightbridge__button-header">
        <mat-icon fontSet="fa" fontIcon="fa-car"></mat-icon> Rental Cars
      </div>
      <div class="flightbridge__button">
        <a *ngIf="isMember" (click)="navigateToFlightBridge('rentalcar')" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Book Now
        </a>
        <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Join AOPA
        </a>
        <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Login/Create AOPA account
        </a>
      </div>
    </div>

    <div class="flightbridge__button-inner-container">
      <div class="flightbridge__button-header">
        <mat-icon fontSet="fa" fontIcon="fa-plane"></mat-icon> Airlines
      </div>
      <div class="flightbridge__button">
        <a *ngIf="isMember" (click)="navigateToFlightBridge('airline')" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Book Now
        </a>
        <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Join AOPA
        </a>
        <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
           class="overview__action aopa-mat-btn aopa-mat-btn--filled">
          Login/Create AOPA account
        </a>
      </div>
    </div>
  </div>
</div>
